import { action as apiAction } from 'api/Api'
import {
  setStartDate,
} from 'routes/Board/redux/cards'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  cardId: number
  startDate: number
}

export default (payload: Payload) => async dispatch => {
  const { cardId, startDate } = payload

  const optimisticAction = optimisticDispatch(dispatch, setStartDate({
    id: cardId,
    startDate
  }))

  try {
    await apiAction('SetStartDate', {
      cardId,
      timestamp: startDate
    })

    optimisticAction.commit()
  } catch (error) {
    optimisticAction.revert()

    throw error
  }
}
